export const colors = {
  monochrome: {
    white: '#ffffffff',
  },
  backgrounds: {
    lighterGrey: '#fafafa',
    lightGrey: '#dbdbdb',
    mediumLightGrey: '#EEEEEE',
    darkGrey: '#6b6b6b',
    white: '#ffffffff',
    green: '#7daa88',
    lightBlue: '#96acbe',
  },
  black: {
    default: '#000000ff',
    ink: '#141414',
    text: '#1a1a1a'
  },
  grey: {
    darker: '#3c3c3c',
    dark: '#6b6b6b',
    medium: '#9a9a9a',
    mediumLight: '#b2b1b1',
    light: '#dbdbdb',
    lighter: '#fafafa',
    soldOut: '#a8a8a8',
    soldOutHover: '#888',
    line: '#e5e5e5',
    lineSoft: '#efefef'
  },
  functions: {
    sale: '#d72e2e',
    star: '#f1c33b',
  },
  brandColors: {
    blue: '#79c6dd',
    green: '#7daa88',
    yellow: '#f2c94c',
    yellowAlternative: '#f9e4a5',
  },
  status: {
    error: '#d72e2e',
    success: '#7daa88',
    waiting: '#f2c94c',
  },
  linkColors: {
    default: '#6b92a8',
  },
  functionColors: {
    specialOffer: '#E0E6EA',
  },
  rgbaFilters: {
    blue: 'rgba(23,27,66,0.5)',
    white50: 'rgba(255,255,255, 0.5)',
    black50: 'rgba(0, 0, 0, 0.5)',
  },
};

export const hex2rgba = (hex: string, alpha = 1) => {
  const [r, g, b] = hex.match(/\w\w/g).map((x) => parseInt(x, 16));
  return `rgba(${r},${g},${b},${alpha})`;
};
